const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'heic', 'heif', 'png', 'webp', 'avif'] as const;

export function isSupportedImageFileName(name: string): boolean {
  const extension = name.split('.').pop()?.toLowerCase();
  return !!extension && IMAGE_EXTENSIONS.includes(extension as (typeof IMAGE_EXTENSIONS)[number]);
}
